import { IV2GeoSchema } from 'shared/repositories/coworking/entities/geo/V2GeoSchema';
import { IOfferV2Schema } from 'shared/repositories/coworking/entities/offer/OfferV2Schema';
import { IOperatorSchema } from 'shared/repositories/coworking/entities/operator/OperatorSchema';
import { IPhotoSchema } from 'shared/repositories/coworking/entities/photo/PhotoSchema';
import { IWorkplacesSchema } from 'shared/repositories/coworking/entities/workplaces/WorkplacesSchema';
import { IWorktimeSchema } from 'shared/repositories/coworking/entities/worktime/WorktimeSchema';

export interface IWorktime {
  /** Работает без выходных **/
  isAllWeek: boolean;
  /** Работает круглосуточно **/
  isRoundTheClock: boolean;
  /** Рабочее время с (например 10:00) **/
  timeFrom?: string | null;
  /** Рабочее время до (например 20:00) **/
  timeTo?: string | null;
}

export interface ICoworking {
  /** Удобства которые есть в коворкинге **/
  amenities: EAmenities[];
  /** Описание коворкинга **/
  description: string;
  /** Номер этажа с которого коворкинг размещается в здании **/
  floorFrom: number;
  /** Номер последнего этажа коворкинга **/
  floorTo: number;
  /** Данные о географическом месторасположении **/
  geo: IV2GeoSchema;
  /** минимальная цена по объявлениям за рабочее место руб/месяц **/
  minPriceForWorkplace?: number | null;
  /** Название коворкинга **/
  name: string;
  /** Объявления по этому коворкингу **/
  offers: IOfferV2Schema[];
  /** Оператор коворкинга **/
  operator: IOperatorSchema;
  /** Список фотографий коворкинга **/
  photos: IPhotoSchema[];
  /** Количество рабочих мест в коворкинге **/
  workplaceCount: number;
  /** Информация о рабочих местах в коворкинге **/
  workplaces: IWorkplacesSchema;
  /** Рабочее время коворкинга **/
  worktime: IWorktimeSchema;
}

export enum EAmenities {
  /** Велопарковка **/
  BikeParking = 'bikeParking',
  /** Кафе **/
  Cafe = 'cafe',
  /** Клининг **/
  Cleaning = 'cleaning',
  /** Участие в мероприятиях **/
  Events = 'events',
  /** Факс **/
  Fax = 'fax',
  /** Флипчарт **/
  Flipchart = 'flipchart',
  /** Фрукты и закуски **/
  Fruits = 'fruits',
  /** Мебель **/
  Furniture = 'furniture',
  /** Спорт-зал **/
  Gym = 'gym',
  /** Высокоскоростной интернет **/
  Internet = 'internet',
  /** Кухня **/
  Kitchen = 'kitchen',
  /** Юридический адрес **/
  LegalAddress = 'legalAddress',
  /** Шкафчики **/
  Lockers = 'lockers',
  /** Переговорные комнаты **/
  MeetingRoom = 'meetingRoom',
  /** Микрофон **/
  Microphone = 'microphone',
  /** Современный ремонт **/
  Modern = 'modern',
  /** Парковка **/
  Parking = 'parking',
  /** Телефонные будки **/
  PhoneBooth = 'phoneBooth',
  /** Принтер и сканер **/
  Printer = 'printer',
  /** Проектор **/
  Projector = 'projector',
  /** Ресепшн **/
  Reception = 'reception',
  /** Зоны отдыха **/
  RestZone = 'restZone',
  /** Охрана **/
  Security = 'security',
  /** Шумопоглощающие панели **/
  SoundAbsorbingPanels = 'soundAbsorbingPanels',
  /** Чай/кофе **/
  Tea = 'tea',
  /** Техническая поддержка **/
  TechSupport = 'techSupport',
  /** Wi-Fi **/
  Wifi = 'wifi',
}
